import { CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { Providers } from 'cleveron-web-components';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { cancelAllWithRouteChange } from '../../actions/apiRequestActionCreator';
import keycloak from '../../keycloak';
import translations from '../../translations';
import ConnectedAppWrapper from '../ConnectedAppWrapper';

const useStyles = makeStyles({
    page: {
        alignContent: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
});

const LoadingPage = ({ id }) => {
    const classes = useStyles();
    return (
        <div className={classes.page} id={id}>
            <CircularProgress size={80} sx={{ marginBottom: '64px', marginTop: '64px' }} />
        </div>
    );
};

function KeycloakProvider({ id }) {
    return (
        <ReactKeycloakProvider
            LoadingComponent={<LoadingPage id={`${id}KeycloakLoadingPage`} />}
            authClient={keycloak}
            initOptions={{
                onLoad: 'login-required',
            }}
        >
            <ConnectedProviders id={id} />
        </ReactKeycloakProvider>
    );
}

function AppProviders({ darkMode, id, locale }) {
    const history = useHistory();

    useEffect(() => history.listen(cancelAllWithRouteChange), [history]);

    useEffect(() => {
        const interval = setInterval(
            () => keycloak.loadUserInfo().catch(() => keycloak.clearToken()),
            10000
        );
        return () => clearInterval(interval);
    }, []);

    return (
        <Providers darkMode={darkMode} locale={locale} translations={translations}>
            <ConnectedAppWrapper id={id} />
        </Providers>
    );
}

function mapStateToProps({ darkMode, locale }) {
    return { darkMode, locale };
}

const ConnectedProviders = connect(mapStateToProps)(AppProviders);

export default KeycloakProvider;
